import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE, DOWNLOAD_EXCEL } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// ChildCategory - Get All (Read)
export const GetProfile = createAsyncThunk(
  "admin/profile/get-all",
  async (_, { rejectWithValue }) => {
    try {

      console.log("profile");
      
      const res = await GET(`${APIS.GetProfile}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const UpdateAppSetUp = createAsyncThunk(
  "masters/app-setup/update",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.getAppSetup}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetAppSetup = createAsyncThunk(
  "admin/profile/get-app-setup",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.getAppSetup}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const FindPassword = createAsyncThunk(
  "auth/password-find",
  async ({data}, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.PasswordFind, data);
      if (res.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const UpdatePassword = createAsyncThunk(
  "auth/password-update",
  async ({data}, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.PasswordUpdate, data);
      if (res.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const UserUpdate = createAsyncThunk(
  "auth/user-update",
  async ({data}, { rejectWithValue }) => {
    try {
      const res = await PUT(APIS.UserUpdate, data);
      if (res.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Slice = createSlice({
  name: "profile",
  initialState: {
    data: {},
    appsetup_data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetProfile.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetProfile.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data ||{};
       
      })
      .addCase(GetProfile.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.appsetup_data = action.payload?.data || {};
      })
      .addCase(GetAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // const index = state.data.findIndex(
        //   (area) => area.id === action.payload?.data?.id,
        // );
        // if (index !== -1) {
        //   state.data[index] = action.payload.data;
        // }
      })
      .addCase(UpdateAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(FindPassword.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(FindPassword.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(FindPassword.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdatePassword.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdatePassword.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(UpdatePassword.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UserUpdate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UserUpdate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(UserUpdate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
